<div *ngIf="model">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li *ngFor="let tab of configTabs.config" class="nav-item" role="presentation">
            <button class="nav-link" [ngClass]="{'active': configTabs.selected == tab.id}"  (click)="configTabs.selected = tab.id" [id]="tab.id + '-tab'" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="false">
            {{tab.name| translate}}
            </button>
        </li>
    </ul>

    <div class="tab-content">
        <!-- DATI ORDINE ACQUISTO -->
        <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 1}" id="1" role="tabpanel" aria-labelledby="home-tab">
            <div style="display: flex;justify-content: end; padding: 10px;">
                <button (click)="addDatiOrdineAcquisto(); notifyChange();">{{'general.add' | translate}}</button>
            </div>
            <div *ngIf="model.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.idDoc' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.date' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.numItem' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.contractCode' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CUPCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CIGCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.rifNLine' | translate}}</th>
                            <th class="col-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let val of model.FatturaElettronicaBody.DatiGenerali.DatiOrdineAcquisto; let i = index;">
                            <td>
                                <input type="text" class="form-control" [ngClass]="[ ((val.CodiceCIG != '' || val.CodiceCUP !='' ) && val.IdDocumento== '')  ? 'borderRed bgLightRed' : '']" [placeholder]="'invoices.edit.relatedDocuments.other.idDoc' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.IdDocumento" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <div class="input-group dm7DatePicker">
                                    <input class="form-control" placeholder="gg-mm-aaaa" 
                                            name="d2" #c2="ngModel" [(ngModel)]="val.Data" readonly
                                            (ngModelChange)="notifyChange()"
                                            ngbDatepicker #d2="ngbDatepicker">
                                    <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important;"
                                        (click)="val.Data = '';notifyChange();" type="button">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                    <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                                        <i class="bi bi-calendar-week"></i>
                                    </button>
                                </div>
                            </td>
                            <td>
                                <input type="text" class="form-control"  [placeholder]="'invoices.edit.relatedDocuments.other.numItem' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.NumItem" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.contractCode' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCommessaConvenzione" (ngModelChange)="notifyChange()">
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.CUPCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCUP" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" placement="right" [ngbTooltip]="'invoices.edit.relatedDocuments.other.tooltip.obbIdDoc' | translate" [placeholder]="'invoices.edit.relatedDocuments.other.CIGCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCIG" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" placement="right" [ngbTooltip]="'invoices.edit.relatedDocuments.other.tooltip.obbIdDoc' | translate" [placeholder]="'invoices.edit.relatedDocuments.other.rifNLine' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoNumeroLinea" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <button type="button" class="btn btn-danger" (click)="deleteDatiOrdineAcquisto(i); notifyChange();"><img src="assets/icone_varie/cestino.svg"></button>
                            </td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
        <!-- DATI CONTRATTO -->
        <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 2}" id="2" role="tabpanel" aria-labelledby="home-tab">
            <div style="display: flex;justify-content: end; padding: 10px;">
                <button (click)="addDatiContratto(); notifyChange();">{{'general.add' | translate}}</button>
            </div>
            <div *ngIf="model.FatturaElettronicaBody.DatiGenerali.DatiContratto">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.idDoc' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.date' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.numItem' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.contractCode' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CUPCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CIGCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.rifNLine' | translate}}</th>
                            <th class="col-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let val of model.FatturaElettronicaBody.DatiGenerali.DatiContratto; let i = index;">
                            <td>
                                <input type="text" class="form-control" [ngClass]="[ ((val.CodiceCIG != '' || val.CodiceCUP !='' ) && val.IdDocumento== '')  ? 'borderRed bgLightRed' : '']"  [placeholder]="'invoices.edit.relatedDocuments.other.idDoc' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.IdDocumento">
                            </td>
                            <td>
                                <div class="input-group dm7DatePicker">
                                    <input class="form-control" placeholder="gg-mm-aaaa" 
                                            name="d2" #c2="ngModel" [(ngModel)]="val.Data"
                                            (ngModelChange)="notifyChange()"
                                            ngbDatepicker #d2="ngbDatepicker" readonly>
                                    <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important;"
                                        (click)="val.Data = '';notifyChange();" type="button">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                    <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                                        <i class="bi bi-calendar-week"></i>
                                    </button>
                                </div>
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.numItem' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.NumItem" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.contractCode' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCommessaConvenzione" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.CUPCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCUP" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.CIGCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCIG" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.rifNLine' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoNumeroLinea" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <button type="button" class="btn btn-danger" (click)="deletedatiContratto(i); notifyChange()"><img src="assets/icone_varie/cestino.svg"></button>
                            </td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
        <!-- DATI CONVENZIONE -->
        <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 3}" id="3" role="tabpanel" aria-labelledby="home-tab">
            <div style="display: flex;justify-content: end; padding: 10px;">
                <button (click)="addDatiConvenzione(); notifyChange();">{{'general.add' | translate}}</button>
            </div>
            <div *ngIf="model.FatturaElettronicaBody.DatiGenerali.DatiConvenzione">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.idDoc' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.date' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.numItem' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.contractCode' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CUPCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CIGCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.rifNLine' | translate}}</th>
                            <th class="col-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let val of model.FatturaElettronicaBody.DatiGenerali.DatiConvenzione; let i = index;">
                            <td>
                                <input type="text" class="form-control" [ngClass]="[ ((val.CodiceCIG != '' || val.CodiceCUP !='' ) && val.IdDocumento== '')  ? 'borderRed bgLightRed' : '']" [placeholder]="'invoices.edit.relatedDocuments.other.idDoc' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.IdDocumento" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <div class="input-group dm7DatePicker">
                                    <input class="form-control" placeholder="gg-mm-aaaa" 
                                            name="d2" #c2="ngModel" [(ngModel)]="val.Data"
                                            (ngModelChange)="notifyChange()"
                                            ngbDatepicker #d2="ngbDatepicker" readonly>
                                    <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important; "
                                        (click)="val.Data = '';notifyChange();" type="button">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                    <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                                        <i class="bi bi-calendar-week"></i>
                                    </button>
                                </div>
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.numItem' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.NumItem" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.contractCode' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCommessaConvenzione" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.CUPCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCUP" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.CIGCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCIG" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.rifNLine' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoNumeroLinea" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <button type="button" class="btn btn-danger" (click)="deletedatiConvenzione(i); notifyChange();"><img src="assets/icone_varie/cestino.svg"></button>
                            </td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
        <!-- DATI RICEZIONE -->
        <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 4}" id="4" role="tabpanel" aria-labelledby="home-tab">
            <div style="display: flex;justify-content: end; padding: 10px;">
                <button (click)="addDatiRicezione(); notifyChange();">{{'general.add' | translate}}</button>
            </div>
            <div *ngIf="model.FatturaElettronicaBody.DatiGenerali.DatiRicezione">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.idDoc' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.date' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.numItem' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.contractCode' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CUPCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CIGCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.rifNLine' | translate}}</th>
                            <th class="col-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let val of model.FatturaElettronicaBody.DatiGenerali.DatiRicezione; let i = index;">
                            <td>
                                <input type="text" class="form-control" [ngClass]="[ ((val.CodiceCIG != '' || val.CodiceCUP !='' ) && val.IdDocumento== '')  ? 'borderRed bgLightRed' : '']"  [placeholder]="'invoices.edit.relatedDocuments.other.idDoc' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.IdDocumento" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <div class="input-group dm7DatePicker">
                                    <input class="form-control" placeholder="gg-mm-aaaa" 
                                            name="d2" #c2="ngModel" [(ngModel)]="val.Data"
                                            (ngModelChange)="notifyChange()"
                                            ngbDatepicker #d2="ngbDatepicker" readonly>
                                    <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important;"
                                        (click)="val.Data = '';notifyChange();" type="button">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                    <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                                        <i class="bi bi-calendar-week"></i>
                                    </button>
                                </div>
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.numItem' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.NumItem" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.contractCode' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCommessaConvenzione" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.CUPCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCUP" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.CIGCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCIG" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.rifNLine' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoNumeroLinea" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <button type="button" class="btn btn-danger" (click)="deletedatiRicezione(i);notifyChange();"><img src="assets/icone_varie/cestino.svg"></button>
                            </td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
        <!-- DATI FATTURE COLLEGATE -->
        <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 5}" id="5" role="tabpanel" aria-labelledby="home-tab">
            <div style="display: flex;justify-content: end; padding: 10px;">
                <button (click)="addDatiFattureCollegate(); notifyChange();">{{'general.add' | translate}}</button>
            </div>
            <div *ngIf="model.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.idDoc' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.date' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.numItem' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.contractCode' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CUPCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.CIGCod' | translate}}</th>
                            <th class="col-9">{{'invoices.edit.relatedDocuments.other.rifNLine' | translate}}</th>
                            <th class="col-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let val of model.FatturaElettronicaBody.DatiGenerali.DatiFattureCollegate; let i = index;">
                            <td>
                                <input type="text" class="form-control" [ngClass]="[ ((val.CodiceCIG != '' || val.CodiceCUP !='' ) && val.IdDocumento== '')  ? 'borderRed bgLightRed' : '']" [placeholder]="'invoices.edit.relatedDocuments.other.idDoc' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.IdDocumento" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <div class="input-group dm7DatePicker">
                                    <input class="form-control" placeholder="gg-mm-aaaa" 
                                            name="d2" #c2="ngModel" [(ngModel)]="val.Data"
                                            (ngModelChange)="notifyChange()"
                                            ngbDatepicker #d2="ngbDatepicker" readonly>
                                    <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important;"
                                        (click)="val.Data = '';notifyChange();" type="button">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                    <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                                        <i class="bi bi-calendar-week"></i>
                                    </button>
                                </div>
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.numItem' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.NumItem" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.contractCode' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCommessaConvenzione" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.CUPCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCUP" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.CIGCod' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.CodiceCIG" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.rifNLine' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoNumeroLinea" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <button type="button" class="btn btn-danger" (click)="deletedatiFattureCollegate(i); notifyChange();"><img src="assets/icone_varie/cestino.svg"></button>
                            </td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
        <!-- DATI SAL -->
        <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 6}" id="6" role="tabpanel" aria-labelledby="home-tab">
            <div style="display: flex;justify-content: end; padding: 10px;">
                <button (click)="addDatiSAL(); notifyChange();">{{'general.add' | translate}}</button>
            </div>
            <div *ngIf="model.FatturaElettronicaBody.DatiGenerali.DatiSAL">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="col-10">{{'invoices.edit.relatedDocuments.other.phaseReference' | translate}}</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let val of model.FatturaElettronicaBody.DatiGenerali.DatiSAL; let i = index;">
                            <td>
                                <input type="text" maxlength="3" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.phaseReference' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoFase" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <button type="button" class="btn btn-danger" (click)="deletedatiSAL(i); notifyChange();"><img src="assets/icone_varie/cestino.svg"></button>
                            </td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
        <!-- DATI DDT -->
        <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 7}" id="7" role="tabpanel" aria-labelledby="home-tab">
            <div style="display: flex;justify-content: end; padding: 10px;">
                <button (click)="addDatiDDT(); notifyChange();">{{'general.add' | translate}}</button>
            </div>
            <div *ngIf="model.FatturaElettronicaBody.DatiGenerali.DatiDDT">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="col-3">{{'invoices.edit.relatedDocuments.other.numDDT' | translate}}</th>
                            <th class="col-3">{{'invoices.edit.relatedDocuments.other.dateDDT' | translate}}</th>
                            <th class="col-3">{{'invoices.edit.relatedDocuments.other.nLineReference' | translate}}</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let val of model.FatturaElettronicaBody.DatiGenerali.DatiDDT; let i = index;">
                            <td>
                                <input type="text" [ngClass]="[(val.NumeroDDT == '')  ? 'borderRed' : '']"  maxlength="20" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.numDDT' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.NumeroDDT">
                            </td>
                            <td>
                                <div class="input-group dm7DatePicker">
                                    <input class="form-control" [ngClass]="[(val.DataDDT == '')  ? 'borderRed' : '']"  placeholder="gg-mm-aaaa"
                                            name="d2" #c2="ngModel" [(ngModel)]="val.DataDDT"
                                            (ngModelChange)="notifyChange()" readonly
                                            ngbDatepicker #d2="ngbDatepicker">
                                    <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important;"
                                        (click)="val.DataDDT = '';notifyChange();" type="button">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                    <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                                        <i class="bi bi-calendar-week"></i>
                                    </button>
                                </div>
                            </td>
                            <td>
                                <input type="number" max="999" min="1" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.nLineReference' | translate" aria-describedby="basic-addon1" [(ngModel)]="val.RiferimentoNumeroLinea" (ngModelChange)="notifyChange()">
                            </td>
                            <td>
                                <button type="button" class="btn btn-danger" (click)="deletedatiDDT(i); notifyChange();"><img src="assets/icone_varie/cestino.svg"></button>
                            </td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
        <!-- FATTURA PRINCIPALE -->
        <div class="tab-pane" [ngClass]="{'active': configTabs.selected == 8}" id="8" role="tabpanel" aria-labelledby="home-tab">
            <table class="table">
                <thead>
                    <tr>
                        <th class="col-6">{{'invoices.edit.relatedDocuments.other.number' | translate}}</th>
                        <th class="col-6">{{'invoices.edit.relatedDocuments.other.date' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input type="text" class="form-control" [placeholder]="'invoices.edit.relatedDocuments.other.number' | translate" aria-describedby="basic-addon1" [(ngModel)]="model.FatturaElettronicaBody.DatiGenerali.FatturaPrincipale.NumeroFatturaPrincipale" (ngModelChange)="notifyChange()">
                        </td>
                        <td>
                            <div class="input-group dm7DatePicker">
                                <input class="form-control" placeholder="gg-mm-aaaa"
                                        name="d2" #c2="ngModel" [(ngModel)]="model.FatturaElettronicaBody.DatiGenerali.FatturaPrincipale.DataFatturaPrincipale"
                                        (ngModelChange)="notifyChange()" readonly
                                        ngbDatepicker #d2="ngbDatepicker">
                                <button class="btn btn-outline-secondary calendar" style="height: 33px !important; border-radius: 0 !important;"
                                    (click)="model.FatturaElettronicaBody.DatiGenerali.FatturaPrincipale.DataFatturaPrincipale = '';notifyChange();" type="button">
                                    <i class="bi bi-x-lg"></i>
                                </button>
                                <button class="btn btn-outline-secondary calendar" (click)="d2.toggle()" type="button">
                                    <i class="bi bi-calendar-week"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>    
            </table>
        </div>
    </div>
</div>
